module.exports = __webpack_public_path__ + "img/PD_4.cc429e89.png";